<template>
  <div class="results-details">
    <modal
      ref="redirectingLaudasa"
      template="question"
      ref-name="redirectingLaudasa"
      first-button-text="Cancelar"
      second-button-text="Continuar"
      :close-button-enabled="true"
      @first-cta="closeLaudasaModal()"
      @second-cta="redirectToLaudasaPage()"
    >
      <p>Você será redirecionado para a plataforma Laudasa.</p>
      <p>Neste site você poderá buscar pelo exame em formato PDF.</p>
      <p class="bold">
        Deseja continuar?
      </p>
    </modal>

    <table class="results-details__table">
      <colgroup>
        <col class="column-check">
        <col class="column-os-alvaro">
        <col class="column-cod-exame">
        <col class="column-data-cadastro">
        <col class="column-data-resultado">
        <col class="column-paciente-id">
        <col class="column-status-result">
        <col class="column-status-result">
        <col class="column-info">
      </colgroup>
      <thead class="results-details__table-head">
        <tr>
          <th class="column-check">
            <div class="styled-checkbox" />
            <md-tooltip
              md-delay="400"
              md-direction="right"
            >
              Selecionar todos
            </md-tooltip>
          </th>
          <th
            title="OS ÁLVARO"
            class="sort-column"
          >
            OS ÁLVARO
          </th>
          <th>
            <span
              title="CÓD. EXAME"
              class="sort-column"
            >CÓD. EXAME</span>
          </th>
          <th
            title="DATA CADASTRO"
            class="sort-column"
          >
            DATA CADASTRO
          </th>
          <th
            title="DATA RESULTADO"
            class="sort-column"
          >
            DATA RESULTADO
          </th>
          <th
            title="EXPORTADO"
            class="sort-column"
          >
            EXPORTADO
          </th>
          <th
            title="ORIGEM"
            class="sort-column"
          >
            ORIGEM
          </th>
          <th />
          <th class="last-column" />
        </tr>
      </thead>

      <tbody
        v-for="(result, rowIndex) in resultsChild"
        :key="rowIndex"
        :md-item="result"
      >
        <tr class="apoio-datatable__line">
          <td class="column-check">
            <div class="styled-checkbox">
              <input
                :id="'chk' + result.id"
                v-model="selected"
                type="checkbox"
                :value="result.id"
              >
              <label
                class="list-checkbox"
                :for="'chk' + result.id"
              />
            </div>
          </td>
          <td>
            <span
              :title="result.numberAlvaroOrder"
              class="os-alvaro-span"
            >{{ result.numberAlvaroOrder }}</span>
          </td>
          <td>
            <span :title="result.examCode">{{ result.examCode }}</span>
          </td>
          <td>
            <span
              :title="format(result.dateTransfer)"
              class="os-date-span"
            >{{ format(result.dateTransfer) }}</span>
          </td>
          <td>
            <span
              :title="format(result.dateResult)"
              class="os-date-result-span"
            >{{ format(result.dateResult) }}</span>
          </td>
          <td>
            <md-icon
              v-if="result.exported"
              md-src="/static/images/icon-exported.svg"
              class="results__icon"
            />
            <md-icon
              v-else
              md-src="/static/images/icon-error-small.svg"
              class="results__icon"
            />
            <span
              :title="$strings.exported[result.exported]"
              class="os-exported-span"
            >{{ $strings.exported[result.exported] }}</span>
          </td>
          <td>
            <span
              v-if="result.codeOriginLis === undefined || result.codeOriginLis === '' || result.codeOriginLis === null"
              title="Manual"
              class="os-exported-span"
            >Manual</span>
            <span
              v-else
              title="Integrado"
              class="os-exported-span"
            >Integrado</span>
          </td>
          <td>
            <div class="tooltip-size">
              <md-icon
                v-if="result.amendment"
                md-src="/static/images/icon-info-small.svg"
                class="results__icon"
              />
              <md-tooltip
                v-if="result.amendment"
                md-delay="400"
                md-direction="left"
              >
                O resultado do exame foi retificado.
              </md-tooltip>
            </div>
          </td>
          <td class="last-column">
            <div v-if="toggle.deepwater">
              <div
                v-if="result.fap"
                class="icon-link"
              >
                <md-tooltip md-direction="left">
                  Esse resultado também está disponível <br>na plataforma Deepwater
                </md-tooltip>
                <a
                  :href="result.urlDeepwater"
                  target="_BLANK"
                  @click="submitEventToAnalytics('Ver resultado no Deep Water')"
                >
                  <div class="icon-report" />
                </a>
              </div>
              <div
                v-else
                class="icon-link"
                @click.prevent.stop="openLaudasaModal()"
              >
                <md-tooltip md-direction="left">
                  Esse resultado também está disponível <br>na plataforma Laudasa
                </md-tooltip>
                <div class="icon-report" />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/common/Spinner'
import loadingInfiniteMessage from '@/components/common/LoadingInfiniteMessage'
import mixin from './resultMixin'
import externalTokensService from '@/api/token'
import { formatDate } from '@/utils/date-utils'
import { concatNameAndCode } from '@/utils/string-utils'
import { mapGetters } from 'vuex'

export default {
  name: 'ResultsDetails',
  components: {
    'infinite-loading': InfiniteLoading,
    'spinner': Spinner,
    'loading-infinite-message': loadingInfiniteMessage
  },
  mixins: [mixin],
  props: ['resultsChild'],
  computed: {
    ...mapGetters(['profile', 'toggle']),
    resultIndex: function () {
      return this.resultsChild[0].patientName
    }
  },
  created () {
    var _self = this
    externalTokensService.callTokenLaudasaService().then(
      function (response) {
        if (response.status === 200) {
          _self.laudasaToken = response.data.token
        }
      }
    )
  },
  methods: {
    format (v) {
      return formatDate(v)
    },
    concatNameCode (name, code) {
      return concatNameAndCode(name, code)
    },
    redirectToLaudasaPage () {
      window.open(process.env.URL_LAUDASA + this.laudasaToken)
      this.closeLaudasaModal()
      this.submitEventToAnalytics('Ver resultado no Laudasa')
    },
    openLaudasaModal () {
      this.$refs.redirectingLaudasa.open()
    },
    closeLaudasaModal () {
      this.$refs.redirectingLaudasa.close()
    },
    submitEventToAnalytics (action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Resultados - Listagem',
        'action': action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    }
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/mixins';

  .results-details {
    .column-check {
      width: 45px;
      padding: 0 0 0 14px;
      border-left: 16px solid #fff
    }
    .last-column {
      border-right: 26px solid #fff
    }
    .column-os-alvaro {
      width: 12%;
    }
    .column-cod-exame {
      width: 13%;
    }
    .column-data-cadastro {
      width: 16%;
    }
    .column-data-resultado {
      width: 16%;
    }
    .column-os-alvaro {
      width: 11%;
    }
    .column-status-result {
      width: 140px;
    }
    .column-paciente-id {
      width: 17%;
    }
    .column-info {
      width: 60px;
      padding: 0 24px 0 0;
    }

    .sort-icon {
      position: relative;
    }

    .apoio-datatable {
      margin-top: 0;
    }

    .apoio-datatable__line {
      cursor: default;
    }

    .tooltip-size{
      width: 20px;
    }

    .cod-mnemonico {
        width: 13%;
    }

    .exams {
        width: 23%;
    }

    .samples-number {
        width: 12%;
    }

    .material {
        width: 10%;
    }

    .fixed-material {
        width: 12%;
    }

    .error {
        width: 20%;
    }

    .status {
        width: 10%;
    }

    .actions {
        width: 8%;
    }

    .spacement {
        width: 1%;
    }
    &__table {
      outline: 16px solid #fff;

      td {
        white-space: normal;
      }

      tr {
      outline: none;
      height: 47px;
      }

      tr:hover {
        font-weight: bold;
        outline: none;
      }
    }

    &__table-head {
      th {
        border-bottom: 2px solid #ffffff;
        white-space: normal;
      }
    }

    .icon-link {
      p {
        cursor: pointer;
      }
    }
  }
</style>
